module.exports = __webpack_public_path__ + "img/compare-6.95a3e422.jpg";